<template>
  <v-dialog v-model="$parent.viewstatus" width="950">
    <div class="printer__container">
      <div class="printer" ref="print">
        <div class="printer__header">
          <img src="../assets/logo.png" class="printer__image" alt />
          <p class="printer__title">Money Transfer Receipt</p>
          <img src="../assets/logo.png" class="printer__image" style="visibility:hidden" alt />
        </div>
        <table class="printer__table">
          <tr class="printer__tr printer__tr--title">
            <td>Sender Details</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="printer__tr">
            <td>Name</td>
            <td>{{$parent.summary.sender}}</td>
            <td>Mobile No</td>
            <td>{{$parent.summary.mobile}}</td>
          </tr>
          <tr class="printer__tr printer__tr--title">
            <td>Retailer Details</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="printer__tr">
            <td>Name</td>
            <td>{{$parent.summary.user_name}}</td>
            <td>Mobile No</td>
            <td>{{$parent.summary.mobile_no}}</td>
          </tr>
          <tr class="printer__tr printer__tr--title">
            <td>Beneficiary Details</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="printer__tr">
            <td>Bank Name</td>
            <td>{{$parent.summary.bank_name}}</td>
            <td>IFSC Code</td>
            <td>{{$parent.summary.bank_ifsc}}</td>
          </tr>
          <tr class="printer__tr">
            <td>Name</td>
            <td>{{$parent.summary.name}}</td>
            <td>Account No</td>
            <td>{{$parent.summary.account}}</td>
          </tr>
          <tr class="printer__tr printer__tr--title">
            <td>Transaction Details</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="printer__tr">
            <td>Total Amount</td>
            <td>{{$parent.summary.amount}}</td>
            <td>Date</td>
            <td>{{$parent.summary.time}}</td>
          </tr>
        </table>
        <table class="printer__table printer__table--border">
          <tr class="printer__tr">
            <td>Transaction Id</td>
            <td>Bank Transaction id</td>
            <td>Transaction Amount</td>
            <td>Status</td>
            <td>Amount</td>
          </tr>
          <tr class="printer__tr">
            <td>{{$parent.summary.tid}}</td>
            <td>{{$parent.summary.bank_txtid}}</td>
            <td>{{$parent.summary.amount}}</td>
            <td>{{$parent.summary.status}}</td>
            <td>{{$parent.summary.amount}}</td>
          </tr>
        </table>
      </div>
      <div class="printer__footer">
        <v-spacer />
        <v-btn color="red" dark @click="$parent.viewstatus = false">Cancel</v-btn>
        <v-btn color="primary" @click="print()">Print</v-btn>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    print() {
      let vm = this;
      const css = `
              @media print {
                body {-webkit-print-color-adjust: exact;}
              }
                .printer {
                  width:100%;
                  background:white;
                }
                .printer__header {
                  display:flex;
                  margin-bottom:20px;
                  justify-content: space-between;
                }
                .printer__image {
                  width: 100px;
                  height: 40px;
                  object-fit: contain;
                }
                .printer__title {
                  font-size: 2rem;
                  float: left;
                  margin:0px;
                  text-align: center;
                }
                .printer__table {
                  width: 100%;
                  border-collapse: collapse;
                }
                .printer__tr td{
                  padding: 10px!important;
                  font-size: 1.2em;
                }
                .printer__tr--title {
                  background:green;
                  font-weight:bold;
                  color:white;
                }
                .printer__table--border td {
                  border: 1px solid lightgrey;
                  margin-bottom: 10px;
                }`;
      const prtHtml = vm.$refs.print.innerHTML;
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <style>
                    ${css}
                    </style>
                </head>
                <body>
                    <div class="printer">
                        ${prtHtml}
                    </div>
                </body>
                </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function() {
        WinPrint.print();
        WinPrint.close();
      }, 500);
    }
  }
};
</script>
<style scoped>
.printer__container {
  background: white;
}
.printer {
  width: 100%;
  background: white;
  padding: 25px;
}
.printer__header {
  display: flex;
  justify-content: space-between;
}
.printer__image {
  width: 100px;
  height: 40px;
  float: left;
  object-fit: contain;
}
.printer__title {
  font-size: 2rem;
  float: left;
  text-align: center;
}
.printer__table {
  width: 100%;
  border-collapse: collapse;
}
.printer__tr td {
  padding: 10px !important;
  font-size: 1.2em;
}
.printer__tr--title {
  background: green;
  font-weight: bold;
  color: white;
}
.printer__table--border td {
  border: 1px solid lightgrey;
  margin-bottom: 10px;
}
.printer__footer {
  display: flex;
  padding-right: 15px;
  padding-bottom: 15px;
}
</style>
